<template>
  <div>
    <Toast />

    <div class="card">
      <h5>
        <b>Detail Mutasi Keluar Barang</b>
      </h5>
      <div class="p-grid">
        <div class="p-col p-mb-5">
          <label for="">Nomor Bon</label>
          <div>{{ summary.doc_number }}</div>
        </div>

        <div class="p-col p-mb-5">
          <label for="">Tanggal Bon</label>
          <div>{{ moment(summary.doc_date).format('DD-MM-YYYY') }}</div>
        </div>

        <div class="p-col p-mb-5" v-if="summary.outlet_name_source">
          <label for="">Outlet Asal</label>
          <div>{{ summary.outlet_name_source }}</div>
        </div>

        <div class="p-col-12">
          <table class="table table-responsive">
            <thead class="thead-light">
              <tr>
                <th>No</th>
                <th>Kode Barang</th>
                <th>Nama Barang</th>
                <th>Status</th>
                <th>Harga</th>
                <th>Qty</th>
                <th>Total Harga</th>
                <th v-if="user.role == 'OUTLET_MANAGER'"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(an_item, k) in outlet_inbounds" :key="k">
                <td>{{ k + 1 }}</td>
                <td>{{ an_item.item_code }}</td>
                <td>{{ an_item.item_name }}</td>
                <td v-if="an_item.status == 1">Disetujui</td>
                <td v-else-if="an_item.status == 2">Ditolak</td>
                <td v-else>Tertunda</td>
                <td>{{ an_item.price | currency }}</td>
                <td>{{ an_item.qty }}</td>
                <td>{{ an_item.total | currency }}</td>
                <td
                  v-if="an_item.status === 0 && user.role == 'OUTLET_MANAGER'"
                >
                  <button
                    class="btn btn-primary"
                    @click="onApproveBtnClick(an_item.id)"
                  >
                    Disetujui
                  </button>
                </td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class="p-text-left">
                  <label for="">Total</label>
                </td>
                <td>{{ summary.total_qty }}</td>
                <td>{{ summary.total_price | currency }}</td>
                <td v-if="user.role == 'OUTLET_MANAGER'"></td>
              </tr>
            </tbody>
          </table>
        </div>

        <Dialog
          :visible.sync="ShowApproveConfirmation"
          :style="{ width: '450px' }"
          header="Setujui Penerimaan Barang"
          :modal="true"
        >
          <div class="confirmation-content">
            <span>
              <b>Anda yakin ingin menerima barang ini ?</b>
            </span>
          </div>
          <template #footer>
            <button
              type="button"
              class="btn btn-primary"
              style="width: 100px"
              @click="onConfirmApprove"
              :disabled="loading_approve"
            >
              APPROVE
              <span v-if="loading_approve">
                <i class="pi pi-spin pi-spinner" style="fontsize: 12px"></i>
              </span>
            </button>
          </template>
        </Dialog>

        <Dialog
          :visible.sync="ShowDenyConfirmation"
          :style="{ width: '450px' }"
          header="Tolak Penerimaan Barang"
          :modal="true"
        >
          <div class="confirmation-content">
            <span>
              <b>Anda yakin ingin menolak barang ini ?</b>
            </span>
          </div>
          <template #footer>
            <Button
              label="TOLAK"
              class="btn btn-primary"
              @click="onDenyApprove"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

var moment = require('moment')
export default {
  data() {
    return {
      moment: moment,
      loading: true,
      loading_approve: false,
      products: null,
      expandedRows: [],
      summary: {},
      outlet_inbounds: null,
      ShowApproveConfirmation: false,
      ShowDenyConfirmation: false,
      outlet_inbound_data: null
    }
  },
  mounted() {
    this.loading = false
    this.getOutlets()
  },
  computed: mapState(['user', 'isAuthenticated']),
  methods: {
    onApproveBtnClick(outlet_inbound) {
      this.outlet_inbound_data = outlet_inbound
      this.ShowApproveConfirmation = true
    },

    onConfirmApprove() {
      this.loading_approve = true
      this.$http
        .patch(
          `${process.env.VUE_APP_API_URL}/dashboard/outlet-inbounds/${this.outlet_inbound_data}/approved`
        )
        .then(response => {
          if (response.status === 200) {
            this.loading_approve = false
            this.$toast.add({
              severity: 'success',
              summary: 'Approvement success',
              detail: 'This item is approved successfully',
              life: 3000
            })
            this.ShowApproveConfirmation = false
            this.outlet_inbound_data = null
            this.getOutlets()
          } else {
            this.loading_approve = false
            this.$toast.add({
              severity: 'error',
              summary: 'Aprrovement failed',
              detail: 'There is a problem in during approving the item',
              life: 3000
            })
            return false
          }
        })
    },

    onDenyBtnClick(outlet_inbound) {
      this.outlet_inbound_data = outlet_inbound
      this.ShowDenyConfirmation = true
    },

    onDenyApprove() {
      this.$http
        .patch(
          `${process.env.VUE_APP_API_URL}/dashboard/outlet-inbound/${this.outlet_inbound_data}/deny`
        )
        .then(response => {
          if (response.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Deny success',
              detail: 'This item is deny successfully',
              life: 3000
            })
            this.ShowDenyConfirmation = false
            this.outlet_inbound_data = null
            this.getOutlets()
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'deny failed',
              detail: 'There is a problem in during deny the item',
              life: 3000
            })
            return false
          }
        })
    },

    getOutlets() {
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/dashboard/outlet-inbound?doc_number=${this.$route.query.doc_number}`
        )
        .then(response => {
          if (response.status === 200) {
            this.summary = response.data.data.summary
            this.outlet_inbounds = response.data.data.outlet_inbounds
          }
        })
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;

  .p-progressbar-value {
    background-color: #607d8b;
  }
}

.p-datatable .p-column-filter {
  display: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
}

/deep/ .p-datatable.p-datatable-outlets {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
    font-size: 1.5rem;
  }

  .p-paginator {
    padding: 1rem;
  }

  .p-datatable-thead > tr > th {
    text-align: left;
  }

  .p-datatable-tbody > tr > td {
    cursor: auto;
  }

  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}

/* Responsive */
.p-datatable-outlets .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-qualified {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-unqualified {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-negotiation {
    background: #feedaf;
    color: #8a5340;
  }

  &.status-new {
    background: #b3e5fc;
    color: #23547b;
  }

  &.status-renewal {
    background: #eccfff;
    color: #694382;
  }

  &.status-proposal {
    background: #ffd8b2;
    color: #805b36;
  }
}

.p-progressbar-value.ui-widget-header {
  background: #607d8b;
}

@media (max-width: 640px) {
  .p-progressbar {
    margin-top: 0.5rem;
  }
}

.product-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.orders-subtable {
  padding: 1rem;
}

.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}
input:disabled {
  color: black;
}

.order-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.order-delivered {
    background: #c8e6c9;
    color: #256029;
  }

  &.order-cancelled {
    background: #ffcdd2;
    color: #c63737;
  }

  &.order-pending {
    background: #feedaf;
    color: #8a5340;
  }

  &.order-returned {
    background: #eccfff;
    color: #694382;
  }
}

@media screen and (max-width: 960px) {
  /deep/ .p-datatable {
    &.p-datatable-outlets {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr {
        > td {
          text-align: left;
          display: block;
          border: 0 none !important;
          width: 100% !important;
          float: left;
          clear: left;

          .p-column-title {
            padding: 0.4rem;
            min-width: 30%;
            display: inline-block;
            margin: -0.4rem 1rem -0.4rem -0.4rem;
            font-weight: bold;
          }

          .p-progressbar {
            margin-top: 0.5rem;
          }
        }
      }
    }
  }
}
</style>
